import type { ImperativeModalProps } from "@web/src/app/entities/imperative-modal";
import EventEmitter from "eventemitter3";

export type NotificationToast = {
  titleColor?: "negative" | "positive" | "warning" | "info";
  key: string;
  title: string;
  content: string;
  duration?: number;
  action?: {
    label: string;
    color?: "negative" | "positive" | "warning" | "info";
    filled?: boolean;
    onClick: () => void;
  };
};

export type CommonEventTypes = {
  SHOW_MODAL: (modal: ImperativeModalProps) => void;
  PUBLISH_TOAST: (notification: Omit<NotificationToast, "key">) => void; // Notifications are non-blocking in nature
  PUBLISH_ALERT: (notification: Omit<NotificationToast, "key">) => void; // Alerts are blocking in nature
  PAYWALL: (options: { from: string }) => void;
  LOGOUT: () => void;
};

export const CommonEvents = new EventEmitter<CommonEventTypes>();
export type TCommonEvent = typeof CommonEvents;
